module.exports = __webpack_public_path__ + "src/images/products/trendsetter/97_Short Sleeve V-Neck.png";